module.exports = __webpack_public_path__ + "media/6.c92869de.mp3";